import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconForwardNext = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.2489 12C20.2489 11.8909 20.2256 11.7871 20.1838 11.6936L20.0612 11.5033C20.0509 11.4916 20.0401 11.4801 20.0289 11.4689L12.78 4.22C12.4867 3.92667 12.0111 3.92667 11.7178 4.21999C11.4245 4.51332 11.4245 4.98889 11.7178 5.28222L17.6845 11.2489H4.75111C4.33628 11.2489 4 11.5852 4 12C4 12.4148 4.33628 12.7511 4.75111 12.7511H17.6845L11.7178 18.7178C11.4245 19.0111 11.4245 19.4867 11.7178 19.78C12.0111 20.0733 12.4867 20.0733 12.78 19.78L20.0289 12.5311L20.0305 12.5295C20.0997 12.4599 20.1524 12.3802 20.1887 12.2951C20.2275 12.2045 20.2489 12.1048 20.2489 12Z",
		fill: "currentColor"
	})
});
export { SvgIconForwardNext as ReactComponent };
